// extracted by mini-css-extract-plugin
export default {"body":"styles_body__1N1ss","body_gap":"styles_body_gap__cb-RR","body_item":"styles_body_item__YdZ0l"};